<template>
  <v-flex>
    <v-toolbar flat class="mx-auto mb-4">
      <v-btn icon v-on:click.native="goBack()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class="headline">Nap Activity Log</v-toolbar-title>

    </v-toolbar>
    <v-flex mx-auto>
      <voice-date-select></voice-date-select>
      <v-layout v-if="false" row wrap mt-4>
        <v-flex xs10>
          <v-progress-linear v-model="vocalActivityValue" height="20" color="success" animate></v-progress-linear>
        </v-flex>
        <v-flex xs2>
          <div class="text-xs-left pl-4">
            <div class="vocal-activity-value headline ">{{ calActVal() }}%</div>
            <div class="vocal-activity-label">{{ vocalActivityValue}} of {{ totalDailyAllotment }} daily allotment</div>
          </div>
        </v-flex>
      </v-layout>
      <voice-data-table postType='NapTaken'></voice-data-table>
      <div class="text-xs-center mt-4">
        <v-btn round color="primary" to="/val">Add Activity</v-btn>
      </div>
    </v-flex>
  </v-flex>
</template>

<script>

  import DateSelect from '../DateSelect.vue'
  import ValDataTable from '../val/ValDataTable.vue'
  import DeleteActivityMutation from '../mutations/DeleteActivityMutation';
  import { ListActivitiesFromCurrentUser, GetActivityByUserQuery } from '@/components/queries';
  import VocalActivityHome from '../home/VocalActivityHome.vue'

  export default {
    data() {
      return {
        switch1: (localStorage.sickMarkerValue === 'true'),
        vocalActivityValue: localStorage.vocalActivityTotal,
        totalDailyAllotment: localStorage.totalDailyAllotment,
      }
    },
    components: {
      'voice-date-select': DateSelect,
      'voice-data-table': ValDataTable,
      'vocal-activity-home': VocalActivityHome,
    },
    computed: {
      percentagVAL(){
        var temp = Math.floor((localStorage.vocalActivityTotal / localStorage.totalDailyAllotment) * 100);
        if (isNaN(temp) || !isFinite(temp)) { temp = 0; }
        return temp;
      }
    },
    methods: {
      goBack() {
        this.$router.back();
      },
    },
    mounted() {
      var that = this;
      this.totalDailyAllotment = localStorage.totalDailyAllotment;
      this.vocalActivityValue = localStorage.vocalActivityTotal;
      this.$root.$on('voiceFeelChange', data => {
        console.log("on emit from details");
        this.totalDailyAllotment = data;
        localStorage.totalDailyAllotment = data;
        // this.percentagVAL = this.calActVal();
      });
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/settings/NapDetails.vue